import { Card } from "@/components/Kpi";
import { ComparisonChart } from "@/components/Charts";
import { eur } from "@/lib/format";

export const PREMI_KEYS = [
  { key: "importo_cvt", name: "CVT", color: "#0284C7" },
  { key: "importo_cpi", name: "CPI", color: "#F59E0B" },
  { key: "importo_nfk", name: "NFK", color: "#059669" },
  { key: "importo_ggn", name: "GGN", color: "#7C3AED" },
];

/** Premi assicurativi liquidati per mese (CVT, CPI, NFK, GGN) + riquadro totali progressivi. */
export const PremiChart = ({ anno, data = [], testId = "chart-premi-liquidati" }) => {
  const tot = data.reduce((a, r) => {
    PREMI_KEYS.forEach((k) => { a[k.key] = (a[k.key] || 0) + (r[k.key] || 0); });
    return a;
  }, {});
  const totale = PREMI_KEYS.reduce((s, k) => s + (tot[k.key] || 0), 0);
  return (
    <div className="grid grid-cols-1 xl:grid-cols-[1fr_240px] gap-6 items-stretch" data-testid={testId}>
      <ComparisonChart testId={`${testId}-grafico`} height={320} title={`Premi assicurativi liquidati per mese · ${anno}`}
        data={data} keys={PREMI_KEYS} emptyNote="dato non disponibile" />
      <Card className="p-5 flex flex-col justify-center border-2 border-slate-400 bg-gradient-to-b from-slate-50 to-white"
        data-testid={`${testId}-totali`}>
        <div className="uppercase text-xs tracking-[0.18em] font-bold text-slate-600">Premi liquidati</div>
        <div className="mt-3 space-y-2.5">
          {PREMI_KEYS.map((k) => (
            <div key={k.key}>
              <div className="text-[10px] uppercase tracking-wider text-slate-400">{k.name}</div>
              <div className="font-mono text-lg font-semibold" style={{ color: k.color }} data-testid={`${testId}-${k.name.toLowerCase()}`}>{eur(tot[k.key] || 0)}</div>
            </div>
          ))}
          <div className="border-t border-slate-200 pt-2.5">
            <div className="text-[10px] uppercase tracking-wider text-slate-400">Totale</div>
            <div className="font-mono text-xl font-semibold text-slate-900" data-testid={`${testId}-totale`}>{eur(totale)}</div>
          </div>
        </div>
      </Card>
    </div>
  );
};
